import { render, staticRenderFns } from "./DifficultySettings.vue?vue&type=template&id=61dcfa8f&scoped=true&"
import script from "./DifficultySettings.vue?vue&type=script&lang=js&"
export * from "./DifficultySettings.vue?vue&type=script&lang=js&"
import style0 from "./DifficultySettings.vue?vue&type=style&index=0&id=61dcfa8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dcfa8f",
  null
  
)

export default component.exports